import { IServerConfig } from './types'

/**
 * Server-only secrets. Import this module ONLY from server contexts:
 *   - pages/api/*
 *   - getServerSideProps / getStaticProps
 *   - SSR-only helpers
 *
 * Non-NEXT_PUBLIC_ env vars are stripped from the browser bundle by Next.js,
 * so these values would resolve to `undefined` if this module were ever
 * imported by client code. Still — don't do that, because it defeats the
 * whole point of keeping secrets off the client-safe `config` object.
 */
const serverConfig: IServerConfig = {
  clientSecret: process.env.CLIENT_SECRET as string,
  cronSecret: process.env.CRON_SECRET as string,
  datadog: {
    apiKey: process.env.DD_API_KEY as string
  },
  recaptcha: {
    secretKey: process.env.RECAPTCHA_SECRET_KEY as string
  },
  hygraph: {
    apiKey: process.env.HYGRAPH_AUTH_TOKEN as string
  }
}

export default serverConfig
